import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import { BC_TESTIMONIALS } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import 'he';
import '../../utils/broadcast.js';
import '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import React from 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../types/Campaign.js';
import '../../types/product.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '@brandclub/types';
import { VideoCarousel } from '../VideoCarousel/index.js';

var BrandclubVideoCarousel = function (props) {
    return React.createElement(VideoCarousel, __assign({ items: BC_TESTIMONIALS }, props));
};

export { BrandclubVideoCarousel };
//# sourceMappingURL=index.js.map
